module.exports = __webpack_public_path__ + "img/title_2.44d892b6.png";